module.exports = __webpack_public_path__ + "static/media/Tyrogue_gaussian2.1742265b.png";